import {
  GqlModel,
  GqlModelListOperator,
  GqlMutationModel,
  GqlQueryModel,
} from "../graphql/graphql.model";
import gql from "graphql-tag";
import {jsonListIndex, JSONModel, jsonProperty} from "../json.model";

export class DeviceBundledItemModel extends JSONModel {
  @jsonProperty("string") productNumber: string;
  @jsonProperty("string") productDescription: string;
}

export class DeviceStatsModel extends JSONModel {
  @jsonProperty("number") total: number;
  @jsonProperty("number") available: number;
  @jsonProperty("number") planned: number;
  @jsonProperty("number") ordered: number;
  @jsonProperty("number") installed: number;
}

export class DeviceGqlModel extends GqlQueryModel {
  static mapper: GqlModelListOperator<DeviceGqlModel> = GqlModel.buildListMapper(DeviceGqlModel, "devices");

  static query: any = gql`
    query getDevices($projectId: ID!, $typeId: Int) {
      devices: devices(projectId: $projectId, typeId: $typeId) {
        __typename
        id
        deviceKey
        productNumber
        productDescription
        bundleNumber
        friendlyName
        billingModel
        stats {
          total
          available
          planned
          ordered
          installed
        }
        ... on AssetDevice {
          disabled
          alreadyUsedQuantity
          quicksilver
          bundledItems {
            productNumber
            productDescription
          }
        }
        ... on AccessoryDevice {
          disabled
        }
      }
    }
  `;

  type: string;
  @jsonProperty("string") id: string;
  @jsonProperty("string") deviceKey: string;
  @jsonProperty("string") productNumber: string;
  @jsonProperty("string") productDescription: string;
  @jsonProperty("string") bundleNumber: string;
  @jsonProperty("string") friendlyName: string;
  @jsonProperty("string") billingModel: string;
  disabled: boolean;
  quicksilver: boolean;
  bundledItems: DeviceBundledItemModel[];
  alreadyUsedQuantity: number;
  @jsonProperty(DeviceStatsModel) stats: DeviceStatsModel;

  @jsonListIndex() index: number;

  static variables(projectId: string, typeId?: number) {
    return {
      projectId,
      ...typeId && {typeId},
    };
  }
}

export class DeviceInputModel extends JSONModel {
  @jsonProperty("string") id: string;
  @jsonProperty("string") type: string;
  @jsonProperty("string") productNumber: string;
  @jsonProperty("string") bundleNumber: string;
  @jsonProperty("string") friendlyName: string;
  @jsonProperty("boolean") disabled: boolean;
  @jsonProperty("number0") alreadyUsedQuantity: number;
}

export class DeviceInputGqlModel extends GqlMutationModel {
  static mapper: GqlModelListOperator<DeviceGqlModel> = GqlModel.buildListMapper(DeviceGqlModel, "devices");

  static query: any = gql`
    mutation updateDevices($projectId: ID!, $devices: [DeviceInput]) {
      devices: devices(projectId: $projectId, devices: $devices) {
        __typename
        id
        deviceKey
        productNumber
        productDescription
        bundleNumber
        friendlyName
        stats {
          total
          available
          planned
          ordered
          installed
        }
        ... on AssetDevice {
          disabled
          alreadyUsedQuantity
          quicksilver
          bundledItems {
            productNumber
            productDescription
          }
        }
        ... on AccessoryDevice {
          disabled
        }
      }
    }
  `;

  @jsonProperty("string") projectId: string;
  @jsonProperty([DeviceInputModel]) devices: DeviceInputModel[];
}

export class AssetDeviceGqlModel extends DeviceGqlModel {
  type: string = "asset";
  @jsonProperty("boolean") disabled: boolean;
  @jsonProperty("boolean") quicksilver: boolean;
  @jsonProperty("number0") alreadyUsedQuantity: number;
  @jsonProperty([DeviceBundledItemModel]) bundledItems: DeviceBundledItemModel[];
}

export class AccessoryDeviceGqlModel extends DeviceGqlModel {
  type: string = "accessory";
  @jsonProperty("boolean") disabled: boolean;
}

export class SoftwareDeviceGqlModel extends DeviceGqlModel {
  type: string = "software";
}

DeviceGqlModel.register("AssetDevice", AssetDeviceGqlModel);
DeviceGqlModel.register("AccessoryDevice", AccessoryDeviceGqlModel);
DeviceGqlModel.register("SoftwareDevice", SoftwareDeviceGqlModel);
